import { INavigateGameData, OperatorEvent } from "../interfaces/theos.interface";
import { registerEventHandler } from "../feim/registerEventHandler";

/**
 * @internal
 * Internal handler for navigate game event
 */
export const handleNavigateGame = (): void =>
{
    registerEventHandler<INavigateGameData>(OperatorEvent._NAVIGATE_GAME)((data: INavigateGameData) =>
    {
        if (data.url !== undefined && (data.url.toLowerCase().startsWith("http:") || data.url.toLowerCase().startsWith("https:"))) {
            window.location.href = data.url;
        }
    });
};